import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tabs, TabsList, TabsTrigger } from '../ui/tabs';

const LanguageSwitch = () => {
  const { i18n } = useTranslation();

  const languages = ['FR', 'NL', 'EN', 'ES'];

  const handleChange = (value) => {
    i18n.changeLanguage(value.toLowerCase());
  };

  return (
    <Tabs 
      defaultValue={i18n.language.toUpperCase()} 
      onValueChange={handleChange}
      data-testid="nav-language-switch"
    >
      <TabsList className="bg-white/5 border border-white/10 h-8">
        {languages.map((lang) => (
          <TabsTrigger
            key={lang}
            value={lang}
            className="text-[10px] px-2 h-6 data-[state=active]:bg-[#C9A84C] data-[state=active]:text-[#060606]"
            data-testid={`language-switch-${lang.toLowerCase()}`}
          >
            {lang}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
};

export default LanguageSwitch;
